import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.css';
import ReduxComponent from "../ReduxComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { 
	Table,
	Button,
	Modal,
	Row,
	Col,
	Icon,
	Popover,
	Form,
	Input,
	Spin,
	Radio,
	message,
	DatePicker,
	TreeSelect,
	Select 
} from 'antd';
import { 
	changeAttendanceTemplate,
	selectAttendanceTemplate,
	updateAttendanceTemplate,
} from '../../actions/attendance-actions';
import DynamicButton from "../../components/frame/DynamicButton";
import DynamicTable from "../../components/frame/DynamicTable";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import { fetchAttendanceList, fetchAttendanceSchedule } from '../../actions/attendance-actions';
import attendanceTemplateService from '../../services/Attendance/attendance-template-service';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';

//const webConfig = require ('../../config.json');
const weekdayMap = ["", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"];

const { TreeNode } = TreeSelect;

class AttendanceTemplate extends ReduxComponent {

	state = {
    order_property:"",
    is_order_asc:true,
		currentModalStatus: false,
		importModalStatus: false,
		currentIndex: false,
		recordModalStatus: false,
		currentData: {},
		recordData: '',
		recordDataStatus: "unload",
		selectedRecordID:[],
		employee_info:"",
    	department_id:""
	}

	initReload = true;
	moduleName = "attendance";
	childModuleName = "attendanceTemplate";

	actions = {
		changeAction: this.props.changeAttendanceTemplate,
		selectAction: this.props.selectAttendanceTemplate,
		updateAction: this.props.updateAttendanceTemplate,

		deleteAction: attendanceTemplateService.deleteAttendanceTemplate,
		createAction: attendanceTemplateService.createAttendanceTemplate,
		appendAction: () => {},

		exportAction: attendanceTemplateService.exportTemplate,
		importAction: attendanceTemplateService.importTemplate,
		downloadTemplateAction: attendanceTemplateService.downloadTemplate,
	}



setRealNameFilter = event => {
    this.setState({ employee_info:event.target.value});
}

componentDidMount() {
    // const urls="http://qi-qd.eicp.net:33075/help/api/HRAttendanceRecords/Get?page=1"
    // fetch(urls,{method:'get',body:{'page':1}}).then(res=>res.json()).then((text)=>{
    // 	console.log(JSON.stringify(text))
    // })
	// this._fetchDepartmentsList()
	this.actions.changeAction({employee_info: ""})

}


_fetchDepartmentsList = () => {
    this.props.fetchDepartmentsList({})
}


setDepartmentFilter = value => {
    this.setState({department_id: value});
}


insertData = () => {
		this.setState({
			currentIndex: null,
			disableEmployee: false,
			disableLongType: false,
			disableShortType: false,
			currentTemplateType: 1,
			currentData: {
				employee_id: "",
				employee_name: "",
				department_id: "",
				department_name: "",
				template_type: 1,
				day_1: "",
				day_1_time: "请选择模版",
				day_2: "",
				day_2_time: "请选择模版",
				day_3: "",
				day_3_time: "请选择模版",
				day_4: "",
				day_4_time: "请选择模版",
				day_5: "",
				day_5_time: "请选择模版",
				day_6: "",
				day_6_time: "请选择模版",
				day_7: "",
				day_7_time: "请选择模版",
				start_time: "",
				end_time: "",
			}
		}, () => this.toggleCurrentModal(true));
	}

	updateData = index => {
		this.setState({
			currentIndex: index,
			disableEmployee: true,
			disableLongType: false,
			disableShortType: true,
			currentTemplateType: this.props[this.moduleName][this.childModuleName].data.Data[index].template_type,
			currentData: {
				...this.props[this.moduleName][this.childModuleName].data.Data[index]
			}
		}, () => this.toggleCurrentModal(true));
	}

	insertShortData = index => {
		this.setState({
			currentIndex: null,
			disableEmployee: true,
			disableLongType: true,
			disableShortType: false,
			currentTemplateType: 1,
			currentData: {
				employee_id: this.props[this.moduleName][this.childModuleName].data.Data[index].employee_id,
				employee_name: this.props[this.moduleName][this.childModuleName].data.Data[index].employee_name,
				department_id: "",
				department_name: this.props[this.moduleName][this.childModuleName].data.Data[index].department_name,
				template_type: 1,
				day_1: "",
				day_1_time: "请选择模版",
				day_2: "",
				day_2_time: "请选择模版",
				day_3: "",
				day_3_time: "请选择模版",
				day_4: "",
				day_4_time: "请选择模版",
				day_5: "",
				day_5_time: "请选择模版",
				day_6: "",
				day_6_time: "请选择模版",
				day_7: "",
				day_7_time: "请选择模版",
				start_time: "",
				end_time: "",
			}
		}, () => this.toggleCurrentModal(true));
	}

	updateShortData = index => {
		this.setState({
			currentIndex: index,
			disableEmployee: true,
			disableLongType: true,
			disableShortType: false,
			currentTemplateType: this.props[this.moduleName][this.childModuleName].data.Data[index].template_type,
			currentData: {
				...this.props[this.moduleName][this.childModuleName].data.Data[index],
				template_type:1
			}
		}, () => this.toggleCurrentModal(true));
	}

setInitData(){
	this.setState({employee_info: ""})
	let params = {
        page: 1,
        department_id:this.state.department_id,
		employee_info:this.state.employee_info
}
    let gets = {};
    gets = { ...gets, ...params }
    this.actions.changeAction(gets)
}

getFilter = () => {
    let params = {
        page: 1,
        department_id:this.state.department_id,
		employee_info:this.state.employee_info
}
    let gets = {};
    gets = { ...gets, ...params }
    this.actions.changeAction(gets)
}


	setPageFilter = (pagination, filters, sorter) => {
    let params = {
      page: pagination.current,
      order_property:sorter.field,
      is_order_asc: sorter.order!== "descend",
		  department_id:this.state.department_id,
			employee_info:this.state.employee_info
    }
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined) {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.actions.changeAction(gets)
  }

	changeEmployee = value => this.props.fetchEmployeesList({real_name: value})

	changeSchedule = value => {
		if (!isNaN(value)) {
			this.props.fetchAttendanceSchedule({search_text: value})			
		}
	}

	selectEmployee = (value, employee) => this.setState({
		currentData: {
			...this.state.currentData,
			employee_id: employee.props.employee_id,
			department_name: employee.props.department_name
		}
	})

	submitCurrentModal = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let currentData = {
					...this.state.currentData,
					...values,
					start_time: values.start_time ? values.start_time.format('YYYY-MM-DD') : null,
					end_time: values.end_time ? values.end_time.format('YYYY-MM-DD') : null
				}
				console.log(currentData)
				let callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

	selectSchedule = (index, value, event) => {

		let currentDataKey = "day_" + index + "_time";
		let copyData = {};
    let currentDataTime = "";
    if (undefined === event.props.index) {
      currentDataTime += "休息日";
    }else{
      const currentDataValue = this.props[this.moduleName][this.childModuleName].schedules[event.props.index];
      currentDataTime += currentDataValue.on_time.slice(0, 5) + "-";
      currentDataTime += currentDataValue.off_time.slice(0, 5);
    }
    copyData[currentDataKey] = currentDataTime;
    console.log(copyData)
		this.setState({
			...this.state,
			currentData: {
				...this.state.currentData,
				...copyData
			}
		});
	}

	setUploadedFile = event => {
		this.setState({uploadedFile: event.target.files[0]});
	}

	uploadFile = () => this.publicImport(this.state.uploadedFile)

	setTemplateType = event => this.setState({currentTemplateType: event.target.value});

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
						{this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})



	column = [{
		title: '工号',
		dataIndex: 'job_number',
		key: 'job_number',
		className: 'table-global-head-small',
    sorter: true
	}, {
		title: '中文名',
		dataIndex: 'employee_name',
		key: 'employee_name',
		className: 'table-global-head-small',
    sorter: true
	}, {
		title: '英文名',
		dataIndex: 'english_name',
		key: 'english_name',
		className: 'table-global-head',
    sorter: true
	}, {
		title: '部门名称',
		dataIndex: 'department_name',
		key: 'department_name',
		className: 'table-global-head',
    sorter: true
	}, {
		title: '周一',
		dataIndex: 'day_1_time',
		key: 'day_1_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周二',
		dataIndex: 'day_2_time',
		key: 'day_2_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周三',
		dataIndex: 'day_3_time',
		key: 'day_3_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周四',
		dataIndex: 'day_4_time',
		key: 'day_4_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周五',
		dataIndex: 'day_5_time',
		key: 'day_5_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周六',
		dataIndex: 'day_6_time',
		key: 'day_6_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周日',
		dataIndex: 'day_7_time',
		key: 'day_7_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '开始时间',
		dataIndex: 'start_time',
		key: 'start_time',
		className: 'table-global-head-short',
    sorter: true
	}, {
		title: '结束时间',
		dataIndex: 'end_time',
		key: 'end_time',
		className: 'table-global-head-short',
    sorter: true
	}, {
		title: '操作',
		dataIndex: 'reply_time_str22',
		key: 'reply_time22',
		className: 'table-global-head-small',
		render: (text, record, index) => 
			<span>
				{ record.template_type === 0 ?
				<span>
					{ this.props.access.attendanceTemplate.long_set_value && <Button icon="edit" size="small" 
						className="row-action-btn"
						onClick={this.updateData.bind(this, index)}>长期调整</Button>}
					{ this.props.access.attendanceTemplate.new_short_set_value && <Button icon="plus-circle-o" size="small"
						className="row-action-btn"
						onClick={this.insertShortData.bind(this, index)}>新增短期调整</Button>}
				</span>
				:
				<span>
					{ this.props.access.attendanceTemplate.u_value && <Button icon="edit" size="small"
						className="row-action-btn"
						onClick={this.updateShortData.bind(this, index)}>编辑</Button>}
				</span>}
				<Button icon="edit" size="small"
						className="row-action-btn"
						onClick={this.selectRecord.bind(this, record.employee_id)}>查看</Button>
				
			</span>
		
	}];

renderTreeNodes = (data) => {
    return data.map((item) => {
        if (item.children) {
            return (
				<TreeNode value={`${item.id}`} title={item.name} key={item.id} dataRef={item}>
                    { item.children.length !== 0 && this.renderTreeNodes(item.children) }
				</TreeNode>
            );
        }
        return <TreeNode {...item} />;
    });
}

	selectRecord = id => this.setState({
		recordModalStatus: true,
		recordIndex: id,
		recordDataStatus: "unload",
	}, () => {
		// console.log(id);
		this.setState({detailID:id})
		const config = {
			title: "查看考勤模版",
			data: {employee_id: id},
			alert:false,
			callee: attendanceTemplateService.selectAttendanceTemplateRecord,
			callback: res => this.setState({
				recordData: res.data.Object.templates,
				recordDataStatus: "loaded"
			})
		}
		
		this.publicHandle(config);
	})

	toggleRecordModal = () => this.setState({
		recordModalStatus: !this.state.recordModalStatus
	})

	recordHeaderColumn = [{
			title: "批量删除",
			icon: "delete",
			click: ()=>{this.publicDeleteDetail()}
		}
	]
	publicDeleteDetail = () => {
		console.log();
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的内容', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				
					attendanceTemplateService.deleteAttendanceTemplate({ids: this.state.selectedIDs}, res => {
						if (res.data.Success) {
							this.setState({selectedIDs: []});
							message.success('删除操作成功', 4);
							const config = {
								title: "查看考勤模版",
								alert:false,
								data: {employee_id: this.state.detailID},
								callee: attendanceTemplateService.selectAttendanceTemplateRecord,
								callback: res => this.setState({
									recordData: res.data.Object.templates,
									recordDataStatus: "loaded"
								})
							}
							
							this.publicHandle(config);
						}else{
							message.error('删除操作失败' + res.data.Errors[0], 4);
						}
					});
				
			},
			onCancel: () => {}
		});
	}
	recordRowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = [];
			selectedRows.forEach(row => {
				if(1 !== row.status_int && 2 !== row.status_int){
					
					ids.push(row.id)
				}
				else{
					message.error("正在执行或者已执行不能删除")
				}
			});
			// console.log(ids);
			this.setState({selectedIDs: ids.map(i=>i)});
			console.log(this.state.selectedRecordID);
		}
	}
	recordColumn = [{title: '工号',
		dataIndex: 'job_number',
		key: 'job_number',
		className: 'table-global-head-small'
	}, {
		title: '中文名',
		dataIndex: 'employee_name',
		key: 'employee_name',
		className: 'table-global-head-small'
	}, {
		title: '英文名',
		dataIndex: 'english_name',
		key: 'english_name',
		className: 'table-global-head'
	}, {
		title: '部门名称',
		dataIndex: 'department_name',
		key: 'department_name',
		className: 'table-global-head'
	}, {
		title: '周一',
		dataIndex: 'day_1_time',
		key: 'day_1_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周二',
		dataIndex: 'day_2_time',
		key: 'day_2_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周三',
		dataIndex: 'day_3_time',
		key: 'day_3_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周四',
		dataIndex: 'day_4_time',
		key: 'day_4_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周五',
		dataIndex: 'day_5_time',
		key: 'day_5_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周六',
		dataIndex: 'day_6_time',
		key: 'day_6_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '周日',
		dataIndex: 'day_7_time',
		key: 'day_7_time',
		className: 'table-global-head-5x',
		render: (text) => (
			<span>
				{ text === "休息日" ?
				<span style={{color:"#ff0000"}}>
					{text}
				</span>
				:
				<span>
					{text}
				</span>}
			</span>
		)
	}, {
		title: '开始时间',
		dataIndex: 'start_time_str',
		key: 'start_time_str',
		className: 'table-global-head-short'
	}, {
		title: '结束时间',
		dataIndex: 'end_time_str',
		key: 'end_time_str',
		className: 'table-global-head-short'
	}, {
		title: '状态',
		dataIndex: 'status',
		key: 'status',
		className: 'table-global-head-small'
	// }, {
	// 	title: '操作',
	// 	dataIndex: 'reply_time_str22',
	// 	key: 'reply_time22',
	// 	className: 'table-global-head',
	// 	render: (text, record, index) => this.props.access.attendanceTemplate.u_value &&
	// 		<span>
	// 			{ record.template_type !== 0 ?
	// 			<span>
	// 				<Button icon="edit" size="small" 
	// 					className="row-action-btn"
	// 					onClick={this.publicDelete.bind(this, index)}>删除</Button>
	// 			</span>
	// 			:
	// 			<span>
	// 				<Button icon="edit" size="small"
	// 					className="row-action-btn" disabled>删除</Button>
	// 			</span>}
				
	// 		</span>
		
	}]
	render(){



		return(
			
			<div className="app-module-item">
				<Modal width="1200px"
					visible={this.state.recordModalStatus}
					title="查看考勤模版"
					destroyOnClose={true}
					onCancel={this.toggleRecordModal}
					onOk={this.toggleRecordModal}
					footer={<Button type="primary" onClick={this.toggleRecordModal}>确定</Button>} >
					{this.state.recordData&&<div>
					<div className="app-module-header">
						<DynamicButton column={this.recordHeaderColumn}
							module={this.childModuleName}
							access={this.props.access} />
					</div>
					<DynamicTable column={this.recordColumn}
						dataStatus={this.state.recordDataStatus}
						dataSource={this.state.recordData.Data}
						pagination={false}
						rowSelection={this.recordRowSelection} />
					</div>}
					
				</Modal>
				<Modal width="800px"
					visible={this.state.importModalStatus}
					title="导入考勤模版"
					destroyOnClose={true}
					onCancel={() => this.setState({importModalStatus: false})}
					footer={<Button type="back" 
						onClick={() => this.setState({importModalStatus: false})}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<div>
							<Button type="primary" onClick={this.publicDownloadTemplate.bind(this, {})}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{marginTop:"40px"}}>
							<div>导入文件</div>
							<Input type="file" style={{height:"38px"}} onChange={this.setUploadedFile} />
							<Button type="primary" style={{marginTop:"20px"}} onClick={this.uploadFile}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
				<Modal width="1200px"
					visible={this.state.currentModalStatus}
					title="考勤模版"
					
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					okText="确定并排班"
					onOk={this.submitCurrentModal} >
					<div className="app-modal-item">
						{this.state.currentData && 
						<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="员工姓名" className='attendance-template'>
									{this.props.form.getFieldDecorator('employee_name', {
										rules: [{ required: true, message: '请输入员工姓名' }],
										initialValue: this.state.currentData.employee_name
									})(
									<Select mode="combobox"
										disabled={this.state.disableEmployee}
										style={{ width: "300px" }}
										onChange={this.changeEmployee}
										filterOption={false}
										placeholder="请输入报告者员工"
										onSelect={this.selectEmployee} >
										{ this.props.employeeManagement.employeeList &&
											this.props.employeeManagement.employeeList.Data instanceof Array &&
											this.props.employeeManagement.employeeList.Data.map(employee => {
											return (
												<Select.Option key={employee.id} 
													value={employee.real_name + '(' + employee.english_name + ')' }
													employee_id={employee.id}
													department_name={employee.department_name}
													style={{width:"276px"}}>
													{employee.real_name + '(' + employee.english_name + ')' }
												</Select.Option>
											)
										})}
									</Select>)}
								</Form.Item>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="部门" className='attendance-template'>
									<Input style={{width: "300px"}} disabled={true}
									value={this.state.currentData.department_name} />
								</Form.Item>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="模版类型" className='attendance-template'>
									{this.props.form.getFieldDecorator('template_type', {
										rules: [],
										initialValue: this.state.currentData.template_type
									})(
									<Radio.Group style={{width:"300px",textAlign:"left"}}
										onChange={this.setTemplateType} >
										<Radio.Button disabled={this.state.disableLongType} value={0}>长期</Radio.Button>
										<Radio.Button disabled={this.state.disableShortType} value={1}>短期</Radio.Button>
									</Radio.Group>)}
								</Form.Item>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Row>
									<Col span={1} />
									{ weekdayMap.map((dayName, index) => {
										if (0 !== index) {
											let dayKey = "day_" + index;
											let dayTime = dayKey + "_time";
											return (
												<Col span={3} key={index}>
													{/*<Form.Item label={dayName}>
														<Popover content={this.state.currentData[dayTime]}>
															{this.props.form.getFieldDecorator(dayKey, {
																rules: [{ required: true, message: '请选择模版' }],
																initialValue: this.state.currentData[dayKey] ? this.state.currentData[dayKey] : 0
															})(
																<Select style={{width: "80px"}}
																	mode="combobox"
																	onChange={this.changeSchedule}
																	onSelect={this.selectSchedule.bind(this, index)}>
																	<Select.Option key={false}
																		value={0}>休息日</Select.Option>
																	{ this.props[this.moduleName][this.childModuleName].schedules &&	this.props[this.moduleName][this.childModuleName].schedules.map((schedule, scheduleIndex) => {
																		if (0 !== schedule.sequence) {
																			return (
																				<Select.Option key={schedule.sequence}
																					index={scheduleIndex}
																					value={schedule.sequence} >
																					{schedule.sequence}
																				</Select.Option>
																			)
																		}
																		return null;
																	})}
																</Select>
															)}
														</Popover>
													</Form.Item>*/}
													<Form.Item label={dayName}>
														<Popover content={this.state.currentData[dayTime]}>
															{this.props.form.getFieldDecorator(dayKey, {
																rules: [{ required: true, message: '请选择模版' }],
																initialValue: this.state.currentData[dayKey] ? this.state.currentData[dayKey] + "" : ''
															})(
																<Select style={{width: "136px"}}
																	mode="combobox"
																	filterOption="false"
																	onChange={this.changeSchedule}
																	onSelect={this.selectSchedule.bind(this, index)}>
																	<Select.Option key={false}
																		value={'0-(休息日)'}>休息日</Select.Option>
																	{ this.props[this.moduleName][this.childModuleName].schedules &&	this.props[this.moduleName][this.childModuleName].schedules.map((schedule, scheduleIndex) => {
																			return (
																				<Select.Option key={schedule.sequence}
																					index={scheduleIndex}
																					value={schedule.sequence +"-(" +schedule.on_time+"-"+schedule.off_time+ ")"} >
																					{schedule.on_time+"-"+schedule.off_time}
																				</Select.Option>
																			)
																	})}
																</Select>
															)}
														</Popover>
													</Form.Item>
												</Col>
											)
										}
										return null;
									})}
									<Col span={2} />
								</Row>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="开始时间" className='attendance-template'>
									{this.props.form.getFieldDecorator('start_time', {
										rules: [{ required: true, message: '请输入开始时间' }],
										initialValue: this.state.currentData.start_time ?
											moment(this.state.currentData.start_time, 'YYYY-MM-DD'): null
									})(<DatePicker style={{width:"300px"}} />)}
								</Form.Item>
							</div>
							{ 1 === this.state.currentTemplateType &&
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="结束时间" className='attendance-template'>
									{this.props.form.getFieldDecorator('end_time', {
										rules: [{ required: true, message: '请输入结束时间' }],
										initialValue: this.state.currentData.end_time&&this.state.currentData.end_time!=="永久" ?
											moment(this.state.currentData.end_time, 'YYYY-MM-DD'): null
									})(<DatePicker style={{width:"300px"}} />)}
								</Form.Item>
							</div>}
						</Form>}
					</div>
				</Modal>

				<div style={{marginBottom: "20px"}}>
					{this.props.access.attendanceTemplate.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.insertData}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.attendanceTemplate.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					{this.props.access.attendanceTemplate.import_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={() => this.setState({importModalStatus: true})}>
							<Icon type="cloud-upload-o" />
							<span>导入</span>
						</Button>
					</div>}
					{this.props.access.attendanceTemplate.export_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicExport.bind(this, {})}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", display:"inline-block"}}>
						<Input placeholder="请输入中文名/英文名/工号" style={{width:"200px",marginRight: "15px", marginBottom: "20px"}} onChange={this.setRealNameFilter}  value={this.state.employee_info}  />


						<span style={{marginRight: "15px", marginBottom: "20px"}}>
						{ this.props.departmentStructure.departmentsList ?
							<TreeSelect style={{ width: 230 }}
										dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
										placeholder="根据部门选择"
										allowClear
										treeDefaultExpandAll
										onChange={this.setDepartmentFilter} >
                                {this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect>:
							<Spin />
                        }
					</span>

						<Button type="primary" style={{marginRight: "15px"}} onClick={this.getFilter.bind(this)}>
							<span>查询</span>
						</Button>

					</div>
				</div>

				<div>

				
				
					<Table columns={this.column}
						   dataSource={this.props.attendance.attendanceTemplate.data.Data}
						   rowKey={record => record.id}
						   scroll={{x: 800}}
						   rowSelection={this.rowSelection}
						   pagination={{
                               total: this.props.attendance.attendanceTemplate.data.Total,
                               pageSize: this.props.attendance.attendanceTemplate.data.PageSize,
                               current: this.props.attendance.attendanceTemplate.filters.page}}
						   onChange={this.setPageFilter.bind(this)} />


				</div>

			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
        departmentStructure: state.departmentStructure,
		attendance: state.attendance,
		employeeManagement: state.employeeManagement,

	}
}
const mapDispatchToProps = {
    fetchDepartmentsList,
	fetchEmployeesList,
	fetchAttendanceList,
	changeAttendanceTemplate,
	selectAttendanceTemplate,
	updateAttendanceTemplate,
	fetchAttendanceSchedule,

}

AttendanceTemplate = Form.create()(AttendanceTemplate);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceTemplate));






// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceTemplate.js